import { bl_wms_item_label_exts_RowClass } from "../../dbschema/bl_wms_item_label_ext.model";
import { bl_wms_item_label_hdr_RowClass } from "../../dbschema/bl_wms_item_label_hdr.model";
import { BaseContainerModel } from "../base-container.model";

export class WMSItemLabelContainerModel extends BaseContainerModel {
  bl_wms_item_label_hdr: bl_wms_item_label_hdr_RowClass = new bl_wms_item_label_hdr_RowClass();
  bl_wms_item_label_exts: bl_wms_item_label_exts_RowClass[] = [];
}

